/* @flow */
import graficoDeLinhas from '../utils/grafico-de-linhas';

type Data = {
    dataFormatada: string,
    quantidade: number,
};

const gerarGraficoPorDias = (dias: Data[]) => {
    graficoDeLinhas({
        resultado: dias.map(dia => [dia.dataFormatada, dia.quantidade]),
        id: 'grafico-dias',
        coluna: ['Dias', 'Quantidade'],
    });
};

export default gerarGraficoPorDias;
